var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuyana(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4541C24.8366 32.4541 32 25.2907 32 16.4541C32 7.61755 24.8366 0.454102 16 0.454102C7.16344 0.454102 0 7.61755 0 16.4541C0 25.2907 7.16344 32.4541 16 32.4541Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.454102C13.1712 0.454102 10.5145 1.18923 8.20874 2.47735V30.4309C10.5146 31.719 13.1712 32.4541 16.0001 32.4541C24.8366 32.4541 32.0001 25.2906 32.0001 16.4541C32.0001 7.6176 24.8366 0.454102 16.0001 0.454102Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25575 2.45088C7.24919 3.00869 6.30931 3.67169 5.45062 4.42544C5.53744 4.34932 5.62512 4.27407 5.7135 4.19982L17.9676 16.4539L5.71344 28.7081C5.625 28.6338 5.53737 28.5586 5.45056 28.4824C6.30925 29.2362 7.24919 29.8991 8.25569 30.457L32 16.4539L8.25575 2.45088Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90429 3.29063C6.41635 3.62851 5.94772 3.99207 5.50116 4.38063L15.9999 16.4543L5.5011 28.5279C5.94766 28.9164 6.41629 29.2801 6.90422 29.6179L29.261 16.4543L6.90429 3.29063Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71347 4.20036C5.35778 4.49923 5.01453 4.81254 4.68628 5.14073L14.6087 16.4545L4.68628 27.7682C5.01453 28.0965 5.35772 28.4099 5.71347 28.7086L17.9676 16.4545L5.71347 4.20036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68628 5.13992C-1.56209 11.3883 -1.56209 21.519 4.68628 27.7674C7.26834 25.1854 9.75166 22.702 16 16.4537L4.68628 5.13992Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuyana);
export default __webpack_public_path__ + "static/media/guyana.0ac2cf57.svg";
export { ForwardRef as ReactComponent };